var _rect, _rect2, _rect3, _rect4, _rect5, _circle, _circle2, _circle3, _circle4, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _rect6, _rect7, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _path29, _path30, _path31, _path32, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgDataTrending = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 17.3115,
    y: 23.9912,
    width: 44.6886,
    height: 32.0088,
    rx: 2.03883,
    fill: "url(#paint0_linear_119_93270)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 17.3115,
    y: 23.9912,
    width: 44.6886,
    height: 32.0088,
    rx: 2.03883,
    fill: "url(#paint1_radial_119_93270)",
    fillOpacity: 0.4
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 17.3115,
    y: 23.9912,
    width: 44.6886,
    height: 32.0088,
    rx: 2.03883,
    fill: "url(#paint2_radial_119_93270)",
    fillOpacity: 0.4
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 17.3115,
    y: 23.9912,
    width: 44.6886,
    height: 32.0088,
    rx: 2.03883,
    fill: "url(#paint3_radial_119_93270)",
    fillOpacity: 0.7
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 17.3115,
    y: 23.9912,
    width: 44.6886,
    height: 32.0088,
    rx: 2.03883,
    fill: "url(#paint4_radial_119_93270)",
    fillOpacity: 0.6
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 54.2266,
    cy: 23.671,
    r: 4.73346,
    fill: "url(#paint5_linear_119_93270)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.0073,
    cy: 24.2231,
    r: 16.0044,
    fill: "url(#paint6_radial_119_93270)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.0073,
    cy: 24.2231,
    r: 16.0044,
    fill: "url(#paint7_radial_119_93270)",
    fillOpacity: 0.3
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.0073,
    cy: 24.2231,
    r: 16.0044,
    fill: "url(#paint8_radial_119_93270)",
    fillOpacity: 0.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0074 40.2276C26.8464 40.2276 34.0118 33.0621 34.0118 24.2232C34.0118 24.1457 34.0112 24.0684 34.0101 23.9912L20.4042 23.9912C18.6961 23.9912 17.3115 25.3758 17.3115 27.0838V40.2127C17.5422 40.2226 17.7742 40.2276 18.0074 40.2276Z",
    fill: "url(#paint9_radial_119_93270)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0074 40.2276C26.8464 40.2276 34.0118 33.0621 34.0118 24.2232C34.0118 24.1457 34.0112 24.0684 34.0101 23.9912L20.4042 23.9912C18.6961 23.9912 17.3115 25.3758 17.3115 27.0838V40.2127C17.5422 40.2226 17.7742 40.2276 18.0074 40.2276Z",
    fill: "url(#paint10_radial_119_93270)",
    fillOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.603 34.8516C20.603 35.0491 20.4429 35.2093 20.2454 35.2093C20.0479 35.2093 19.8878 35.0491 19.8878 34.8516C19.8878 34.6541 20.0479 34.494 20.2454 34.494C20.4429 34.494 20.603 34.6541 20.603 34.8516Z",
    fill: "#B154FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0788 37.1075C24.0788 37.305 23.9187 37.4651 23.7212 37.4651C23.5237 37.4651 23.3636 37.305 23.3636 37.1075C23.3636 36.91 23.5237 36.7499 23.7212 36.7499C23.9187 36.7499 24.0788 36.91 24.0788 37.1075Z",
    fill: "#B154FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8024 30.7931C23.8024 31.0355 23.6059 31.232 23.3636 31.232C23.1212 31.232 22.9247 31.0355 22.9247 30.7931C22.9247 30.5508 23.1212 30.3543 23.3636 30.3543C23.6059 30.3543 23.8024 30.5508 23.8024 30.7931Z",
    fill: "#B154FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9212 26.4995C30.9212 26.695 30.7627 26.8534 30.5673 26.8534C30.3719 26.8534 30.2134 26.695 30.2134 26.4995C30.2134 26.3041 30.3719 26.1456 30.5673 26.1456C30.7627 26.1456 30.9212 26.3041 30.9212 26.4995Z",
    fill: "#B154FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0669 31.6004C29.0669 31.7623 28.9357 31.8935 28.7738 31.8935C28.6119 31.8935 28.4807 31.7623 28.4807 31.6004C28.4807 31.4386 28.6119 31.3074 28.7738 31.3074C28.9357 31.3074 29.0669 31.4386 29.0669 31.6004Z",
    fill: "#B154FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4835 30.7511C25.4835 31.0237 25.2626 31.2446 24.99 31.2446C24.7175 31.2446 24.4966 31.0237 24.4966 30.7511C24.4966 30.4786 24.7175 30.2577 24.99 30.2577C25.2626 30.2577 25.4835 30.4786 25.4835 30.7511Z",
    fill: "#B154FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4967 31.6149C26.4967 31.8654 26.2935 32.0686 26.0429 32.0686C25.7924 32.0686 25.5892 31.8654 25.5892 31.6149C25.5892 31.3643 25.7924 31.1611 26.0429 31.1611C26.2935 31.1611 26.4967 31.3643 26.4967 31.6149Z",
    fill: "#B154FF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1573 31.3074C19.1573 31.393 19.0958 31.4625 19.0199 31.4625C18.944 31.4625 18.8824 31.393 18.8824 31.3074C18.8824 31.2217 18.944 31.1522 19.0199 31.1522C19.0958 31.1522 19.1573 31.2217 19.1573 31.3074Z",
    fill: "#B154FF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6182 35.0541C28.6182 35.1398 28.5566 35.2093 28.4807 35.2093C28.4048 35.2093 28.3433 35.1398 28.3433 35.0541C28.3433 34.9684 28.4048 34.8989 28.4807 34.8989C28.5566 34.8989 28.6182 34.9684 28.6182 35.0541Z",
    fill: "#B154FF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8824 25.9371C18.8824 26.0522 18.7891 26.1456 18.6739 26.1456C18.5587 26.1456 18.4653 26.0522 18.4653 25.9371C18.4653 25.8219 18.5587 25.7285 18.6739 25.7285C18.7891 25.7285 18.8824 25.8219 18.8824 25.9371Z",
    fill: "#B154FF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M8.54498 15.4972C8.54498 15.7831 8.31322 16.0149 8.02733 16.0149C7.74145 16.0149 7.50969 15.7831 7.50969 15.4972C7.50969 15.2114 7.74145 14.9796 8.02733 14.9796C8.31322 14.9796 8.54498 15.2114 8.54498 15.4972Z",
    fill: "#D6A5FF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M8.26487 18.5358C8.26487 18.8428 8.01602 19.0917 7.70905 19.0917C7.40207 19.0917 7.15322 18.8428 7.15322 18.5358C7.15322 18.2289 7.40207 17.98 7.70905 17.98C8.01602 17.98 8.26487 18.2289 8.26487 18.5358Z",
    fill: "#D6A5FF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4907 14.1828C22.4907 14.3803 22.3306 14.5404 22.1331 14.5404C21.9355 14.5404 21.7754 14.3803 21.7754 14.1828C21.7754 13.9853 21.9355 13.8252 22.1331 13.8252C22.3306 13.8252 22.4907 13.9853 22.4907 14.1828Z",
    fill: "#D6A5FF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1608 16.3253C27.1608 16.5228 27.0006 16.6829 26.8031 16.6829C26.6056 16.6829 26.4455 16.5228 26.4455 16.3253C26.4455 16.1278 26.6056 15.9677 26.8031 15.9677C27.0006 15.9677 27.1608 16.1278 27.1608 16.3253Z",
    fill: "#D6A5FF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7777 32.7024C12.7777 32.8999 12.6176 33.06 12.4201 33.06C12.2226 33.06 12.0625 32.8999 12.0625 32.7024C12.0625 32.5049 12.2226 32.3448 12.4201 32.3448C12.6176 32.3448 12.7777 32.5049 12.7777 32.7024Z",
    fill: "#D6A5FF"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7374 16.7477C15.7374 16.9452 15.5773 17.1053 15.3798 17.1053C15.1823 17.1053 15.0221 16.9452 15.0221 16.7477C15.0221 16.5502 15.1823 16.3901 15.3798 16.3901C15.5773 16.3901 15.7374 16.5502 15.7374 16.7477Z",
    fill: "#D6A5FF"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99117 28.0962C7.99117 28.2937 7.83106 28.4538 7.63355 28.4538C7.43604 28.4538 7.27593 28.2937 7.27593 28.0962C7.27593 27.8987 7.43604 27.7386 7.63355 27.7386C7.83106 27.7386 7.99117 27.8987 7.99117 28.0962Z",
    fill: "#D6A5FF"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M7.16405 27.6379C7.16405 27.7861 7.04385 27.9064 6.89558 27.9064C6.7473 27.9064 6.6271 27.7861 6.6271 27.6379C6.6271 27.4896 6.7473 27.3694 6.89558 27.3694C7.04385 27.3694 7.16405 27.4896 7.16405 27.6379Z",
    fill: "#D6A5FF"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M5.9559 27.7386C5.9559 27.8868 5.8357 28.007 5.68742 28.007C5.53915 28.007 5.41895 27.8868 5.41895 27.7386C5.41895 27.5903 5.53915 27.4701 5.68742 27.4701C5.8357 27.4701 5.9559 27.5903 5.9559 27.7386Z",
    fill: "#D6A5FF"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M6.61271 19.0194C6.61271 19.2485 6.427 19.4342 6.19792 19.4342C5.96884 19.4342 5.78313 19.2485 5.78313 19.0194C5.78313 18.7903 5.96884 18.6046 6.19792 18.6046C6.427 18.6046 6.61271 18.7903 6.61271 19.0194Z",
    fill: "#D6A5FF"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M10.17 21.6058C10.17 21.721 10.0766 21.8144 9.96146 21.8144C9.84628 21.8144 9.75291 21.721 9.75291 21.6058C9.75291 21.4906 9.84628 21.3973 9.96146 21.3973C10.0766 21.3973 10.17 21.4906 10.17 21.6058Z",
    fill: "#D6A5FF"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6695 14.5404C24.6695 14.6556 24.5761 14.749 24.461 14.749C24.3458 14.749 24.2524 14.6556 24.2524 14.5404C24.2524 14.4253 24.3458 14.3319 24.461 14.3319C24.5761 14.3319 24.6695 14.4253 24.6695 14.5404Z",
    fill: "#D6A5FF"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7966 19.2574C26.7966 19.4409 26.6479 19.5896 26.4644 19.5896C26.2809 19.5896 26.1321 19.4409 26.1321 19.2574C26.1321 19.0739 26.2809 18.9251 26.4644 18.9251C26.6479 18.9251 26.7966 19.0739 26.7966 19.2574Z",
    fill: "#D6A5FF"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4644 20.4818C26.4644 20.6653 26.3156 20.8141 26.1321 20.8141C25.9486 20.8141 25.7999 20.6653 25.7999 20.4818C25.7999 20.2983 25.9486 20.1496 26.1321 20.1496C26.3156 20.1496 26.4644 20.2983 26.4644 20.4818Z",
    fill: "#D6A5FF"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3742 21.9161C27.3742 22.0516 27.2644 22.1614 27.1289 22.1614C26.9935 22.1614 26.8837 22.0516 26.8837 21.9161C26.8837 21.7807 26.9935 21.6709 27.1289 21.6709C27.2644 21.6709 27.3742 21.7807 27.3742 21.9161Z",
    fill: "#D6A5FF"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3798 14.9796C15.3798 15.0948 15.2864 15.1881 15.1712 15.1881C15.056 15.1881 14.9627 15.0948 14.9627 14.9796C14.9627 14.8644 15.056 14.7711 15.1712 14.7711C15.2864 14.7711 15.3798 14.8644 15.3798 14.9796Z",
    fill: "#D6A5FF"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 44.2744,
    y: 46.4336,
    width: 23.8448,
    height: 2.42136,
    rx: 1.21068,
    transform: "rotate(-67.7095 44.2744 46.4336)",
    fill: "url(#paint11_linear_119_93270)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 15.1938,
    height: 2.2535,
    rx: 1.12675,
    transform: "matrix(-0.966061 -0.258314 -0.258314 0.966061 47.2603 45.6738)",
    fill: "url(#paint12_linear_119_93270)"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.6689,
    cy: 42.6198,
    r: 3.66747,
    transform: "rotate(-16.0393 31.6689 42.6198)",
    fill: "url(#paint13_radial_119_93270)"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.6689,
    cy: 42.6198,
    r: 3.66747,
    transform: "rotate(-16.0393 31.6689 42.6198)",
    fill: "url(#paint14_radial_119_93270)",
    fillOpacity: 0.5
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.6689,
    cy: 42.6198,
    r: 3.66747,
    transform: "rotate(-16.0393 31.6689 42.6198)",
    fill: "url(#paint15_radial_119_93270)",
    fillOpacity: 0.8
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 45.8335,
    cy: 46.2876,
    r: 3.66747,
    fill: "url(#paint16_radial_119_93270)"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 45.8335,
    cy: 46.2876,
    r: 3.66747,
    fill: "url(#paint17_radial_119_93270)",
    fillOpacity: 0.5
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 45.8335,
    cy: 46.2876,
    r: 3.66747,
    fill: "url(#paint18_radial_119_93270)",
    fillOpacity: 0.8
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M49.501 23.9912C49.6404 26.4823 51.7047 28.4594 54.2307 28.4594C56.7567 28.4594 58.8209 26.4823 58.9604 23.9912H49.501Z",
    fill: "url(#paint19_radial_119_93270)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M49.501 23.9912C49.6404 26.4823 51.7047 28.4594 54.2307 28.4594C56.7567 28.4594 58.8209 26.4823 58.9604 23.9912H49.501Z",
    fill: "url(#paint20_radial_119_93270)",
    fillOpacity: 0.8
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M49.501 23.9912C49.6404 26.4823 51.7047 28.4594 54.2307 28.4594C56.7567 28.4594 58.8209 26.4823 58.9604 23.9912H49.501Z",
    fill: "url(#paint21_radial_119_93270)",
    fillOpacity: 0.5
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.0115 23.6816V23.9909H34.3191C34.3202 24.0681 34.3207 24.1454 34.3207 24.2229C34.3207 33.2326 27.0168 40.5365 18.0071 40.5365C17.774 40.5365 17.542 40.5316 17.3112 40.5219V40.2124L17.002 40.1975V27.0835C17.002 25.2047 18.525 23.6816 20.4039 23.6816H34.0115ZM17.3112 27.0835V40.2124C17.5419 40.2223 17.7739 40.2273 18.0071 40.2273C26.846 40.2273 34.0115 33.0618 34.0115 24.2229C34.0115 24.1454 34.0109 24.0681 34.0098 23.9909H20.4039C18.6958 23.9909 17.3112 25.3755 17.3112 27.0835Z",
    fill: "#F2F1F3"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_119_93270",
    x1: 59.2917,
    y1: 21.9653,
    x2: 29.4509,
    y2: 85.0326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.367698,
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.713542,
    stopColor: "#C9F5FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_119_93270",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.5002 45.0625) rotate(21.8565) scale(4.47912 7.23043)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.322917,
    stopColor: "#6E7B83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.713542,
    stopColor: "#9EA8AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.957884,
    stopColor: "#E4E9EA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_119_93270",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.5002 49.5625) rotate(22.8337) scale(3.86541 6.20588)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.332951,
    stopColor: "#6E7B83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.708333,
    stopColor: "#9EA8AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFEBEE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_119_93270",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(53.4464 25.8257) rotate(33.6214) scale(5.16846 7.86399)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.332951,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.737958,
    stopColor: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.931599,
    stopColor: "#E7E7E7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_119_93270",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.0176 30.5631) rotate(82.0811) scale(20.764 21.5636)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.521657,
    stopColor: "#9EA8AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.684443,
    stopColor: "#D4F0F7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_119_93270",
    x1: 58.3863,
    y1: 18.3383,
    x2: 47.8874,
    y2: 34.2315,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.267843,
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.713542,
    stopColor: "#C9F5FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_119_93270",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.0073 18.1934) rotate(165.746) scale(31.4763 34.3109)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.46884,
    stopColor: "#FFEFE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.906523,
    stopColor: "#FFF7F1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_119_93270",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.75 29.6934) rotate(-35.1972) scale(37.7126 42.5804)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.440888,
    stopColor: "#E7C0A8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.540596,
    stopColor: "#B59174"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_119_93270",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.0073 40.2285) rotate(-90) scale(28.5352 9.47411)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.255305,
    stopColor: "#B59174"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.728744,
    stopColor: "#E7C0A8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_119_93270",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.125 35.9443) rotate(-45.3951) scale(38.4498 47.4401)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.187649,
    stopColor: "#FFD84E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.369792,
    stopColor: "#FE843A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_119_93270",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.6616 23.9912) rotate(-180) scale(19.4116 8.62739)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.330298,
    stopColor: "#C84B00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.607194,
    stopColor: "#FF853B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_119_93270",
    x1: 55.1158,
    y1: 43.5667,
    x2: 55.0742,
    y2: 49.2004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.597549,
    stopColor: "#E2D7CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.739583,
    stopColor: "#D5BFAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.832491,
    stopColor: "#B89F8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.933497,
    stopColor: "#CEBCAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2D7CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_119_93270",
    x1: 6.9081,
    y1: -2.66814,
    x2: 6.85146,
    y2: 2.57471,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.597549,
    stopColor: "#E2D7CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.739583,
    stopColor: "#D5BFAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.832491,
    stopColor: "#B89F8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.933497,
    stopColor: "#CEBCAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2D7CF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_119_93270",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(32.3625 40.939) rotate(108.435) scale(6.74227)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1FFB7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#B9DC4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.645065,
    stopColor: "#6FB12F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7C03"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_119_93270",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.5424 46.2873) rotate(-90) scale(2.65575 5.24827)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAB5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC499",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_119_93270",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.6689 42.6198) rotate(97.8153) scale(6.51015)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.446038,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.841379,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_119_93270",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.5271 44.6068) rotate(108.435) scale(6.74227)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCF2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#4ECBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.645065,
    stopColor: "#0083F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C955FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_119_93270",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(45.707 49.9551) rotate(-90) scale(2.65575 5.24827)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEB3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC99FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_119_93270",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(45.8335 46.2876) rotate(97.8153) scale(6.51015)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.446038,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.841379,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_119_93270",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(54.9572 22.2502) rotate(120.331) scale(9.08743 9.02473)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.103226,
    stopColor: "#FFD7EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.322917,
    stopColor: "#FFA9D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.510417,
    stopColor: "#F388BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#FCB9D9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_119_93270",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(54.246 23.633) rotate(97.7057) scale(8.56513 8.448)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.446038,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.841379,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_119_93270",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(54.0819 28.4594) rotate(-90) scale(3.49497 6.80873)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB3BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE625D",
    stopOpacity: 0
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDataTrending, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Data Trending.d670addd.svg";
export { ForwardRef as ReactComponent };